/* eslint-disable  */
import React, { useEffect, useState } from 'react';
import { Container, Table, Header, Button } from 'semantic-ui-react';
import { api } from '#/apis';
import Dimmer from '+/Dimmer';
import Dayjs from 'dayjs';



const LeaseTradeOut = props => {

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState(false);

    const [formData, setFormData] = useState({
      unit: 'none',
      time: 'month',
      bedrooms: false,
      unitType: false,
      month: true,
      year: false,
      lastTimeParam: 'month',
      currentYear: false // Initialize as false
    });


    useEffect(() => {
        setLoading(true);
        api.get(`/trade_out/''/month/false`)
            .then(({ data }) => {
                // console.log(data)
                setData(data.rows);
                setLoading(false);
            })
            .catch(err => {
                setErr(true);
            });
    }, []);

    const handleUnitInputChange = (e) => {
      const { name, type, value, checked  } = e.target;

      const newValue = type === 'checkbox' ? checked : value;

      let unitValue = name;
      if (!newValue) {
        unitValue = 'none'
      }

      if (name === 'bedrooms') {
          setFormData({ ...formData,
              unit: unitValue,
              [name]: !formData.bedrooms,
              'unitType': false
            });
      } 
      else if ( name === 'unitType') {
          setFormData({ ...formData,
              unit: unitValue,
              [name]: !formData.unitType,
              'bedrooms': false
             });
      }
    }

    const handleTimeInputChange = (e) => {
      const { name, type, value, checked  } = e.target;

      const newValue = type === 'checkbox' ? checked : value;

      if (newValue) {

          if (name === 'month') {
            setFormData({ ...formData,
                time: name,
                [name]: !formData.month,
                'year': false
              });
        } 
        else if ( name === 'year') {
            setFormData({ ...formData,
                time: name,
                [name]: !formData.year,
                'month': false
              });
        }
      }

      
    }
  
    const handleInputChange = (e) => {
      const { name  } = e.target;
      
      setFormData({ ...formData,
          [name]: !formData[name]
        });
    }


    const handleSubmit = async (e) => {
      e.preventDefault();
  
      // console.log(formData)
  
      const{
          unit,
          time,
          currentYear
      } =formData
  
      const { data } = await api.get(`/trade_out/${unit}/${time}/${currentYear}`)
      setData(data.rows);
      setFormData({ ...formData,
        lastTimeParam: time
       });
  
    }

    if (err){
        return <Dimmer message='SOMETHING WENT WRONG, PLEASE RELOAD PAGE' />;
    }

    if (loading || !data) return <Dimmer message='Loading....This may take a while.'/>;

    const displayorNot = (data, i) => {

        if (i === 0){
            return data[i].name
        }

       if (data[i-1].name === data[i].name) {
        return ""
       }
       return data[i].name
    }

    return (
        <Container fluid className='overflow-x'>
            <Header content='Lease Trade out'/>
            <form onSubmit={handleSubmit}>
              <h3>Group By:</h3>
            <div>
              <label>Bedroom Count:</label>
              <input
                type="checkbox"
                name="bedrooms"
                checked={formData.bedrooms}
                onChange={handleUnitInputChange}
              />
            </div>
            <div>
              <label>Unit Type:</label>
              <input
                type="checkbox"
                name="unitType"
                checked={formData.unitType}
                onChange={handleUnitInputChange}
              />
            </div>
            <div>
              <label>Month-Year:</label>
              <input
                type="checkbox"
                name="month"
                checked={formData.month}
                onChange={handleTimeInputChange}
              />
            </div>
            <div>
              <label>Year:</label>
              <input
                type="checkbox"
                name="year"
                checked={formData.year}
                onChange={handleTimeInputChange}
              />
            </div>
            <h3>Limit Results</h3>
            <div>
              <label>Show Only Current Year:</label>
              <input
                type="checkbox"
                name="currentYear"
                checked={formData.currentYear}
                onChange={handleInputChange}
              />
            </div>
            <Button variant='contained' size='small' onClick={handleSubmit}>
                  Submit
          </Button>
          </form>
            <Table>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell content='Property' />
                        <Table.HeaderCell content='# Bedroom' />
                        <Table.HeaderCell content='UnitType' />
                        <Table.HeaderCell content='Date' />
                        <Table.HeaderCell content='Renewed #' />
                        <Table.HeaderCell content='AVG Prior Rent' />
                        <Table.HeaderCell content='Prior Rent' />
                        <Table.HeaderCell content='AVG Current ' />
                        <Table.HeaderCell content='Current Rent' />
                        <Table.HeaderCell content='Increase' />
                        <Table.HeaderCell content='Percent Increase' />
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {(data || []).map((row, i) => {

                      let dateFormat;
                      if (formData.lastTimeParam === 'year' ){
                        dateFormat = 'YYYY'
                      }
                      else if (formData.lastTimeParam === 'month'){
                        dateFormat = 'MM-YY'
                      }
    
  

                        return(<Table.Row key={i}>
                            <Table.Cell content={displayorNot(data, i)} />
                            <Table.Cell content={row.num_bedroom || ''} />
                            <Table.Cell content={row.unit_type_name || ''} />
                            <Table.Cell content={Dayjs(row.date_trunc).add(1, 'days').format(dateFormat)} />
                            <Table.Cell content={row.renewed} />
                            <Table.Cell content={row.avg_prior_rent} />
                            <Table.Cell content={row.prior_rent} />
                            <Table.Cell content={row.avg_current_rent} />
                            <Table.Cell content={row.current_rent} />
                            <Table.Cell content={row.rent_diff} />
                            <Table.Cell content={ '%' +(row.percent_rent_diff * 100.00).toFixed(2) } />
                        </Table.Row>)
                      })}
                </Table.Body>
            </Table>

        </Container>
    );
};


export default LeaseTradeOut;